export type SearchFilterValue = string | number;

export const hasSearchFilterValue = (
  value: SearchFilterValue | null | undefined
): boolean =>
  value !== null && value !== undefined && String(value).trim() !== '';
